const data = [
  {
    id: 1,
    exam_with_year: "M.Tech I Year I Sem R19 Reg March 2023",
    exam: "M.Tech I Year I Sem R19 Reg",
    code: "RE110323",
    batch: "M.Tech R19 [2022-2024]",
    semester: "I Year I Semester",
    examtype: "main",
    any: "common",
    month: "March",
    year: "2023",
    Type: "self",
    path: "/layout/examdata/manageexamination",
  },
  {
    id: 2,
    exam_with_year: "MBA I Year I Sem R19 Reg February 2023",
    exam: "MBA I Year I Sem R19 Reg",
    code: "RD110223",
    batch: "MBA R19 [2022-2024]",
    semester: "I Year I Semester",
    examtype: "main",
    any: "common",
    month: "february",
    year: "2023",
    Type: "self",
    path: "/layout/examdata/manageexamination",
  },
  {
    id: 3,
    exam_with_year: "MCA I Year I Sem R20 Reg February 2023",
    exam: "MCA I Year I Sem R20 Reg",
    code: "RC110223",
    batch: "MCA R20 [2022-2024]",
    semester: "I Year I Semester",
    examtype: "main",
    any: "common",
    month: "february",
    year: "2023",
    Type: "self",
    path: "/layout/examdata/manageexamination",
  },
  {
    id: 4,
    exam_with_year: "B.Tech I Year I Sem R20 Supply February 2023",
    exam: "B.Tech I Year I Sem R20 Supply",
    code: "RS11223",
    batch: "",
    semester: "",
    examtype: "supply",
    any: "common",
    month: "february",
    year: "2023",
    Type: "2,3",
    path: "/layout/examdata/manageexamination",
  },
  {
    id: 5,
    exam_with_year: "B.Tech I Year I Sem R20 Reg February 2023",
    exam: "B.Tech I Year I Sem R20 Reg",
    code: "R1110223",
    batch: "B.Tech R20 [2022-2026]",
    semester: "I Year I Semester",
    examtype: "main",
    any: "common",
    month: "february",
    year: "2023",
    Type: "self",
    path: "/layout/examdata/manageexamination",
  }
];

export default data;
